import { http } from '../services';

class PessoaService {
    async pessoaForm() {
        return http.get('/pessoas/form');
    }

    async getPessoasByValue(value) {
        return http.get('/pessoas/buscar-pessoas', { value });
    }

    async getNomeByValue(value) {
        return http.get('/pessoas/buscar-nome', { value });
    }

    async emailJaExiste(value, codigoPessoa) {
        const pessoa = await http.get('/pessoas/pessoa-por-email', { email: value, codigoPessoa });
        return pessoa;
    }

    async getPessoasListagem({
        pageIndex,
        rowsPerPage,
        columnSort,
        orderSort,
        searchIndex,
        searchText,
        searchOperator,
    }) {
        return http.get('/pessoas', {
            pageIndex,
            rowsPerPage,
            columnSort,
            orderSort,
            searchIndex,
            searchText,
            searchOperator,
        });
    }

    async getCount({ searchIndex, searchText, searchOperator }) {
        return http.get('/pessoas/count', {
            searchIndex,
            searchText,
            searchOperator,
        });
    }

    // async getPessoas() {
    //     return http.get('/pessoas');
    // }

    save(pessoa) {
        return http.post('/pessoas', pessoa);
    }

    update(pessoa) {
        return http.put('/pessoas', pessoa);
    }

    getPessoa(pessoa) {
        return http.get(`/pessoas/${pessoa}`);
    }

    getPessoaNiveis(pessoa) {
        return http.get(`/pessoas/niveis/${pessoa}`);
    }

    delete(pessoa) {
        return http.delete('/pessoas', pessoa);
    }
}

const pessoaService = new PessoaService();
export default pessoaService;
